module.exports = "../../static/img/svo.35bfba7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about_us_main/svo.jpg
// module id = LZgv
// module chunks = 1